/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateSettingRequest
 */
export interface CreateSettingRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateSettingRequest
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSettingRequest
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof CreateSettingRequest
     */
    group: string | null;
}

/**
 * Check if a given object implements the CreateSettingRequest interface.
 */
export function instanceOfCreateSettingRequest(value: object): value is CreateSettingRequest {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('group' in value) || value['group'] === undefined) return false;
    return true;
}

export function CreateSettingRequestFromJSON(json: any): CreateSettingRequest {
    return CreateSettingRequestFromJSONTyped(json, false);
}

export function CreateSettingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSettingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': json['value'],
        'group': json['group'],
    };
}

export function CreateSettingRequestToJSON(json: any): CreateSettingRequest {
    return CreateSettingRequestToJSONTyped(json, false);
}

export function CreateSettingRequestToJSONTyped(value?: CreateSettingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'value': value['value'],
        'group': value['group'],
    };
}

